import config from '../config';
import { collectDeviceProfile } from './deviceProfile';

const LOCAL_STORAGE_DEVICE_KEY = 'squash_device_settings';

export interface DeviceSettings {
  deviceId: string;
  email?: string;
  refereeName?: string;
  refereePlayerId?: string;

  passkeyCredentialId?: string;
  passkeyRegisteredAt?: string;
  isStandalone?: boolean;
  deviceProfile?: any;
  
  // Competitie & Club (cascading instellingen)
  seizoen?: string;
  geslacht?: string;
  klasse?: string;
  afdeling?: string;
  pouleId?: number;
  teamId?: number;
  teamName?: string;
}

// Genereert een UUID v4
function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// Initialiseert of haalt apparaatinstellingen op
export const getDeviceSettings = (): DeviceSettings => {
  const saved = localStorage.getItem(LOCAL_STORAGE_DEVICE_KEY);
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch (e) {
      console.warn('Kon opgeslagen device settings niet parsen, genereer nieuw ID.');
    }
  }

  // Maak nieuw device ID aan
  const newSettings: DeviceSettings = {
    deviceId: `SQ-DEV-${generateUUID().substring(0, 8).toUpperCase()}`,
    seizoen: 'SBN Competitie 2026-2027', // Standaard seizoen
  };
  localStorage.setItem(LOCAL_STORAGE_DEVICE_KEY, JSON.stringify(newSettings));
  return newSettings;
};

// Slaat instellingen lokaal op en stuurt ze naar de proxy server
export const saveDeviceSettings = async (
  email: string,
  refereeName: string,
  refereePlayerId: string,
  isStandalone?: boolean
): Promise<DeviceSettings> => {
  const currentSettings = getDeviceSettings();
  const updatedSettings: DeviceSettings = {
    ...currentSettings,
    email,
    refereeName,
    refereePlayerId,

    isStandalone: isStandalone ?? (window.matchMedia('(display-mode: standalone)').matches || (navigator as any).standalone || false),
    deviceProfile: collectDeviceProfile()
  };

  // 1. Sla lokaal op
  localStorage.setItem(LOCAL_STORAGE_DEVICE_KEY, JSON.stringify(updatedSettings));

  // 2. Sla centraal op in de database via de API
  try {
    const response = await fetch(`${config.apiUrl}/api/v1/device/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updatedSettings),
    });
    
    if (!response.ok) {
      console.error('Fout bij het registreren van device bij proxy server:', response.statusText);
    } else {
      console.log('Apparaat succesvol centraal geregistreerd.');
    }
  } catch (error) {
    console.error('Kan de proxy server niet bereiken om device te registreren:', error);
  }

  return updatedSettings;
};
